<div class="row">
  @for (chart of stackedBarData; track $index; let index = $index) {
  <div class="col-lg-12">
    <div class="card">
      <!--  Enhanced Card Header with Controls -->
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="flex-grow-1">
          <h4 class="fs-20 fs-lg-24 mb-1">
            {{ _translate.currentLang == "en" ? chart.titleEn: chart.titleAr}}
            <span ngbTooltip="{{_translate.currentLang == 'en' ? chart.descriptionEn: chart.descriptionAr}}"
              placement="right">
              <img src="/assets/images/svg/icon-info.svg" alt="" class="wh-20">
            </span>
          </h4>
        </div>
        <!--  Chart Control Buttons -->
        <div class="chart-controls d-flex gap-2">
          <!--  NEW: Data Aggregation Dropdown -->
          <div class="dropdown" ngbDropdown>
            <button class="btn btn-sm btn-outline-info" type="button" ngbDropdownToggle
              [ngbTooltip]="'Data Granularity: ' + getCurrentAggregation()">
              <i class="ri-time-line me-1"></i>
              {{ getCurrentAggregation() | titlecase }}
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <h6 class="dropdown-header">Data Granularity</h6>
              @for (agg of aggregationOptions; track agg.value) {
              <button class="dropdown-item d-flex align-items-center justify-content-between" type="button"
                (click)="onAggregationChange(index, agg.value)" [class.active]="getCurrentAggregation() === agg.value">
                <div class="d-flex align-items-center">
                  @if (agg.value === 'daily') {
                  <i class="ri-calendar-line me-2"></i>
                  }
                  @if (agg.value === 'weekly') {
                  <i class="ri-calendar-2-line me-2"></i>
                  }
                  @if (agg.value === 'monthly') {
                  <i class="ri-calendar-event-line me-2"></i>
                  }
                  {{ agg.label }}
                  <small class="text-muted ms-2">
                    {{ getAggregationDescription(agg.value) }}
                  </small>
                </div>
                @if (getCurrentAggregation() === agg.value) {
                <i class="ri-check-line text-success"></i>
                }
              </button>
              }
              <div class="dropdown-divider"></div>
              <small class="dropdown-item-text text-muted">
                <i class="ri-information-line me-1"></i>
                Auto-selected based on data size
              </small>
            </div>
          </div>
          <!--  NEW: Quarter Filter Dropdown -->
          <div class="dropdown" ngbDropdown>
            <button class="btn btn-sm btn-outline-primary" type="button" ngbDropdownToggle
              [ngbTooltip]="'Filter by ' + getCurrentQuarter(index)">
              <i class="ri-calendar-line me-1"></i>
              {{ getCurrentQuarter(index) }}
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <h6 class="dropdown-header">Select Quarter</h6>
              @for (quarter of quarterFilters; track quarter.value) {
              <button class="dropdown-item d-flex align-items-center justify-content-between" type="button"
                (click)="onQuarterFilterChange(index, quarter.value)"
                [class.active]="getCurrentQuarter(index) === quarter.value">
                <div class="d-flex align-items-center">
                  @if (quarter.value !== 'ALL') {
                  <i class="ri-calendar-check-line me-2"></i>
                  }
                  @if (quarter.value === 'ALL') {
                  <i class="ri-calendar-line me-2"></i>
                  }
                  {{ quarter.label }}
                  @if (quarter.value !== 'ALL') {
                  <small class="text-muted ms-2">
                    ({{ getQuarterMonths(quarter.value) }})
                  </small>
                  }
                </div>
                @if (getCurrentQuarter(index) === quarter.value) {
                <i class="ri-check-line text-success"></i>
                }
              </button>
              }
            </div>
          </div>
          <!--  Data Labels Toggle -->
          <button type="button" class="btn btn-sm"
            [class]="isCashDataLabelsEnabled(index) ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="toggleCashDataLabels(index)"
            [ngbTooltip]="isCashDataLabelsEnabled(index) ? 'Hide Values' : 'Show Values'">
            <i class="ri-price-tag-3-line"></i>
          </button>
          <!--  Chart Type Selector -->
          <div class="dropdown" ngbDropdown>
            <button class="btn btn-sm btn-outline-secondary" type="button" ngbDropdownToggle
              [ngbTooltip]="getCurrentCashChartType(index)">
              <i class="ri-bar-chart-2-line"></i>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              @for (chartType of availableChartTypes; track chartType.value) {
              <button class="dropdown-item d-flex align-items-center justify-content-between" type="button"
                (click)="changeCashChartType(index, chartType.value)"
                [class.active]="getCurrentCashChartType(index) === chartType.value">
                <div class="d-flex align-items-center">
                  <i class="{{chartType.icon}} me-2"></i>
                  {{chartType.label}}
                </div>
                @if (getCurrentCashChartType(index) === chartType.value) {
                <i class="ri-check-line text-success"></i>
                }
              </button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="w-100">
          <!--  Enhanced chart with template reference -->
          <apx-chart #chart dir="ltr" class="apex-charts" [chart]="cashPositioningNew[index]?.chart"
            [series]="cashPositioningNew[index]?.series" [legend]="cashPositioningNew[index]?.legend"
            [stroke]="cashPositioningNew[index]?.stroke" [colors]="cashPositioningNew[index]?.colors"
            [fill]="cashPositioningNew[index]?.fill" [dataLabels]="cashPositioningNew[index]?.dataLabels"
            [xaxis]="cashPositioningNew[index]?.xaxis" [markers]="cashPositioningNew[index]?.markers"
            [plotOptions]="cashPositioningNew[index]?.plotOptions" [yaxis]="cashPositioningNew[index]?.yaxis"
            [tooltip]="cashPositioningNew[index]?.tooltip" [grid]="cashPositioningNew[index]?.grid"
            [labels]="cashPositioningNew[index]?.labels" dir="ltr">
          </apx-chart>
        </div>
      </div>
    </div>
  </div>
  }
</div>